<template>
  <el-dialog
    :model-value="visible"
    title="确定订单"
    :width="isMobile ? '90%' : '650px'"
    @update:model-value="emit('update:visible', $event)"
    :show-close="true"
    center
    class="mobile-dialog"
  >
    <div class="order-details">
      <div class="section">
        <div class="section-title">
          <el-icon><Document /></el-icon>
          <span class="ml-1">核对订单:</span>
        </div>
        <div class="detail-item">
          <span class="label">论文标题:</span>
          <span class="value title-bg">{{ order.title }}</span>
          <span class="value title-bg ml-2">{{ order.wordNumber }}字</span>
        </div>
        <div class="detail-item">
          <span class="label">生成内容:</span>
          <span class="value">封面 | 摘要 | 目录 | 正文 | 致谢 | 参考文献 高度原创</span>
        </div>
        <div class="detail-item">
          <span class="label">订单编号:</span>
          <span class="value">{{ orderNumber || '加载中...' }}</span>
        </div>
        <div class="detail-item">
          <span class="label">免费服务:</span>
          <span class="value">一般查重率在18%左右，官方查重超过25%可以全额退费或重新生成。</span>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          <el-icon><Wallet /></el-icon>
          <span class="ml-1">订单支付:</span>
          </div>
        
        <!-- 移动端支付按钮 -->
        <div v-if="isMobile" class="mobile-payment">
          <div class="payment-amount">
            特惠价: ¥{{ price }}
            <del class="original-price">原价: ¥{{ originalPrice }}</del>
          </div>
          <!-- 折扣提示 -->
          <div class="discount-tip">
            <div v-if="!isLoggedIn" class="login-tip" @click="handleLoginClick">
              登录后支付可享受累计折扣优惠 →
            </div>
            <div v-else-if="userDiscountInfo" class="discount-info">
              🎉 <strong>{{ generateDiscountText(userDiscountInfo) }}</strong>
            </div>
          </div>
          <button type="button" class="benefits-link" @click="handleBenefitsClick">
            <el-icon><Ticket /></el-icon>
            <span>点击查看更多折扣信息</span>
            <el-icon class="benefits-link-arrow"><ArrowRight /></el-icon>
          </button>
          <div class="payment-buttons">
            <el-button 
              type="primary" 
              size="large" 
              class="payment-btn alipay-btn"
              :loading="isLoadingPayment"
              @click="handleMobilePayment('alipay')"
            >
              <el-icon><Wallet /></el-icon>
              支付宝支付
            </el-button>
            <el-button
              type="success"
              size="large"
              class="payment-btn wechat-btn"
              :loading="isLoadingPayment"
              @click="handleMobilePayment('wechat')"
            >
              <el-icon><Wallet /></el-icon>
              微信支付
            </el-button>
            <el-button
              type="warning"
              size="large"
              class="payment-btn activation-btn-mobile"
              :loading="isLoadingActivation"
              @click="showMobileActivationDialog = true"
            >
              <el-icon><Wallet /></el-icon>
              激活码支付
            </el-button>
          </div>
          <div class="payment-tips">
            <div class="tip-item">如遇支付问题, 请联系客服微信</div>
            <div class="tip-item">付款成功前请不要关闭此窗口。</div>
          </div>
        </div>

        <!-- PC端支付二维码 -->
        <el-tabs v-else v-model="activePayment" class="demo-tabs">
          <el-tab-pane label="微信支付" name="wechat">
              <div class="flex items-center">
                <div class="qr-code-container">
                  <div v-if="isLoadingQrCode" class="loading-container">
                    <el-icon class="loading-icon"><Loading /></el-icon>
                    <div class="loading-text">正在生成二维码...</div>
                  </div>
                  <img v-else :src="wechatQrCode" alt="QR Code" class="qr-code-image" />
                </div>
              <div class="payment-info">
              <div class="scan-text">扫码支付</div>
              <div class="amount">
                特惠价: ¥{{ price }}
                <del class="original-price">原价: ¥{{ originalPrice }}</del>
              </div>
              <!-- 折扣提示 -->
              <div class="discount-tip-pc">
                <div v-if="!isLoggedIn" class="login-tip" @click="handleLoginClick">
                  登录后支付可享受累计折扣优惠 →
                </div>
                <div v-else-if="userDiscountInfo" class="discount-info">
                  🎉 <strong>{{ generateDiscountText(userDiscountInfo) }}</strong>
                </div>
              </div>
              <button type="button" class="benefits-link" @click="handleBenefitsClick">
                <el-icon><Ticket /></el-icon>
                <span>点击查看更多折扣信息</span>
                <el-icon class="benefits-link-arrow"><ArrowRight /></el-icon>
              </button>
              <div class="payment-prompt">如遇支付问题, 请联系客服微信</div>
              <div class="payment-prompt">付款成功前请不要关闭此窗口。</div>
            </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="支付宝" name="alipay">
            <div class="flex items-center">
                <div class="qr-code-container">
                  <div v-if="isLoadingQrCode" class="loading-container">
                    <el-icon class="loading-icon"><Loading /></el-icon>
                    <div class="loading-text">正在生成二维码...</div>
                  </div>
                  <iframe v-else-if="alipayHtml" :srcdoc="alipayHtml" class="qr-code-image" frameborder="0" />
                  <img v-else :src="alipayQrCode" alt="QR Code" class="qr-code-image" />
                </div>
              <div class="payment-info">
              <div class="scan-text">扫码支付</div>
              <div class="amount">
                特惠价: ¥{{ price }}
                <del class="original-price">原价: ¥{{ originalPrice }}</del>
              </div>
              <!-- 折扣提示 -->
              <div class="discount-tip-pc">
                <div v-if="!isLoggedIn" class="login-tip" @click="handleLoginClick">
                  登录后支付可享受累计折扣优惠 →
                </div>
                <div v-else-if="userDiscountInfo" class="discount-info">
                  🎉 <strong>{{ generateDiscountText(userDiscountInfo) }}</strong>
                </div>
              </div>
              <button type="button" class="benefits-link" @click="handleBenefitsClick">
                <el-icon><Ticket /></el-icon>
                <span>点击查看更多折扣信息</span>
                <el-icon class="benefits-link-arrow"><ArrowRight /></el-icon>
              </button>
              <div class="payment-prompt">如遇支付问题, 请联系客服微信</div>
              <div class="payment-prompt">付款成功前请不要关闭此窗口。</div>
            </div>
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane label="兑换码" name="code">
            <el-input v-model="promoCode" placeholder="请输入兑换码"></el-input>
          </el-tab-pane> -->
          <el-tab-pane label="激活码" name="activationCode">
            <div class="activation-code-container">
              <div class="activation-input-wrapper">
                <el-input
                  v-model="activationCode"
                  placeholder="请输入激活码"
                  class="activation-input"
                  :loading="isLoadingActivation"
                  @keyup.enter="handleActivationCodePayment"
                />
                <el-button
                  type="primary"
                  class="activation-btn"
                  :loading="isLoadingActivation"
                  @click="handleActivationCodePayment"
                >
                  确认使用
                </el-button>
              </div>
              <div class="activation-tips">
                <div class="tip-item">请确认激活码的有效性和适用范围</div>
                <div class="tip-item">使用激活码后订单将立即完成支付</div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <!-- 论文预览 -->
      <div class="section preview-section">
        <div class="section-title">
          <el-icon><View /></el-icon>
          <span class="ml-1">论文预览:</span>
        </div>
        <div class="paper-preview-box">
          <div class="preview-item">
            <div class="preview-page-meta">
              <span>封面</span>
              <span>01</span>
            </div>
            <div class="preview-page">
              <div class="page-scaler">
                <CoverPage :title="order.title" />
              </div>
            </div>
          </div>
          <div class="preview-item">
            <div class="preview-page-meta">
              <span>目录</span>
              <span>02</span>
            </div>
            <div class="preview-page">
              <div class="page-scaler">
                <TableOfContentsPage :catalogs="order.catalogs" />
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </el-dialog>

  <!-- 移动端激活码输入弹窗 -->
  <el-dialog
    :model-value="showMobileActivationDialog"
    title="激活码支付"
    :width="isMobile ? '90%' : '400px'"
    @update:model-value="showMobileActivationDialog = $event"
    :show-close="true"
    center
    class="mobile-activation-dialog"
  >
    <div class="mobile-activation-content">
      <div class="activation-input-section">
        <el-input
          v-model="mobileActivationCode"
          placeholder="请输入激活码"
          size="large"
          class="mobile-activation-input"
          :loading="isLoadingActivation"
          @keyup.enter="handleMobileActivationPayment"
        />
      </div>

      <div class="activation-buttons">
        <el-button
          size="large"
          @click="showMobileActivationDialog = false"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          size="large"
          :loading="isLoadingActivation"
          @click="handleMobileActivationPayment"
        >
          确认使用
        </el-button>
      </div>

      <div class="mobile-activation-tips">
        <div class="tip-item">• 请确认激活码的有效性和适用范围</div>
        <div class="tip-item">• 使用激活码后订单将立即完成支付</div>
        <div class="tip-item">• 激活码一经使用无法退回</div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup lang="ts">
import { defineProps, ref, defineEmits, toRefs, onMounted, watch, onUnmounted, computed } from 'vue';
import { ArrowRight, Document, Loading, Ticket, View, Wallet } from '@element-plus/icons-vue'
import { get, post, getBaseURL, getUserDiscountByPay, useActivationCode } from '@/api/api';
import { ElMessage } from 'element-plus';
import QRCode from 'qrcode';
import { SourceTracker } from '@/utils/sourceTracker';
import CoverPage from '@/view/CoverPage.vue';
import TableOfContentsPage from '@/view/TableOfContentsPage.vue';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  order: {
    type: Object,
    required: true,
  },
  isLoggedIn: {
    type: Boolean,
    default: false,
  },
  onShowLogin: {
    type: Function,
    default: () => {},
  },
});

const emit = defineEmits(['update:visible', 'payment-success', 'show-benefits']);
const { visible } = toRefs(props);
const activePayment = ref('wechat');
// const promoCode = ref('');
const price = ref(''); // 默认价格
const originalPrice = ref(''); // 原价
const wechatQrCode = ref('@/assets/logo.png'); // 微信支付二维码URL
const alipayQrCode = ref('@/assets/logo.png'); // 支付宝二维码URL
const alipayHtml = ref(''); // 支付宝HTML内容
const isLoadingQrCode = ref(false); // 二维码加载状态
const isLoadingPayment = ref(false); // 移动端支付按钮加载状态
const orderNumber = ref(''); // 从支付接口返回的订单编号
const pollTimer = ref<ReturnType<typeof setInterval> | null>(null); // 轮询定时器
const userDiscountInfo = ref<any>(null); // 用户折扣信息
const activationCode = ref(''); // 激活码内容
const isLoadingActivation = ref(false); // 激活码支付加载状态

// 移动端激活码相关
const showMobileActivationDialog = ref(false); // 移动端激活码弹窗显示状态
const mobileActivationCode = ref(''); // 移动端激活码内容

// 检测是否为移动设备
const isMobile = computed(() => {
  return window.innerWidth <= 768;
});

// 获取用户折扣信息
const fetchUserDiscount = async () => {
  if (!props.isLoggedIn) {
    userDiscountInfo.value = null;
    return;
  }

  try {
    const response = await getUserDiscountByPay();
    if (response.data && response.data.code === 0) {
      userDiscountInfo.value = response.data;
    } else {
      userDiscountInfo.value = null;
    }
  } catch (error) {
    console.error('获取用户折扣信息失败:', error);
    userDiscountInfo.value = null;
  }
};

// 生成折扣文案
const generateDiscountText = (discountInfo: any) => {
  if (!discountInfo) return '';

  const { current, next, remaining } = discountInfo;

  let text = '';

  // 前半段文案
  if (current) {
    text += `当前享受${current}，`;
  } else {
    text += '目前未达到折扣条件，';
  }

  // 后半段文案
  if (!remaining) {
    text += '您已达到最高优惠等级';
  } else {
    text += `再支付${remaining}笔订单则可享受${next}`;
  }

  return text;
};

// 处理登录点击
const handleLoginClick = () => {
  if (props.onShowLogin) {
    props.onShowLogin();
  }
};

// 打开权益信息；未登录时先引导用户登录
const handleBenefitsClick = () => {
  if (!props.isLoggedIn) {
    handleLoginClick();
    return;
  }

  emit('show-benefits');
};

// 获取价格
const getPrice = async () => {
  try {
    const wordCount = props.order.wordNumber || 6000;
    const response = await get('/aiGenerate/getPrice', {
      wordCount: wordCount
    });
    if (response.data && response.data.data) {
      if (response.data.data.discountsPrice) {
        price.value = response.data.data.discountsPrice;
      }
      if (response.data.data.price) {
        originalPrice.value = response.data.data.price;
      }
    }
  } catch (error) {
    console.error('获取价格失败:', error);
  }
};

// 生成订单
const generateOrder = async () => {
  try {
    // 先获取价格
    await getPrice();
    
    const requestData = {
      payType: 1,
      count: 1,
      businessData: buildBusinessData(),
      sourceUrl: SourceTracker.getSourceUrlForOrder()
    };
    
    const response = await post('/aiGenerate/generateOrder', requestData);
    
    if (response.data && response.data.data) {
      orderNumber.value = response.data.data;
      console.log('订单生成成功，订单号:', orderNumber.value);
      console.log('来源URL:', SourceTracker.getSourceUrl());
    }
  } catch (error) {
    console.error('生成订单失败:', error);
    ElMessage.error('生成订单失败，请重试');
  }
};

// 构建businessData参数
const buildBusinessData = () => {
  // 从fiveStep组件获取catalogs数据
  const catalogs = props.order.catalogs || [];
  
  // 处理catalogs数据结构：去掉id字段，将label换成title
  const processedCatalogs = catalogs.map((item: any) => ({
    title: item.label || item.title || '',
    children: item.children ? item.children.map((child: any) => ({
      title: child.label || child.title || '',
      children: child.children ? child.children.map((grandChild: any) => ({
        title: grandChild.label || grandChild.title || ''
      })) : []
    })) : []
  }));
  
  const businessData = {
    content: props.order.content || '',
    keywords: props.order.keywords ? props.order.keywords.join(',') : '',
    literature: props.order.literature ? JSON.stringify(props.order.literature) : '',
    digest: props.order.abstract || '',
    wordCount: props.order.wordNumber || 6000,
    title: props.order.title || '',
    type: 0, // 论文类型
    pageNum: 1, // 默认页码
    catalogs: processedCatalogs,
    sourceUrl: SourceTracker.getSourceUrlForOrder()
  };
  
  return JSON.stringify(businessData);
};

// 检测是否为微信浏览器
const isWechatBrowser = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('micromessenger') !== -1;
};

// 移动端支付处理
const handleMobilePayment = async (paymentType: 'alipay' | 'wechat') => {
  try {
    isLoadingPayment.value = true;
    
    if (!orderNumber.value) {
      ElMessage.error('订单号不存在，请重新生成订单');
      return;
    }
    
    // 根据支付类型选择不同的GET接口，直接跳转
    let apiEndpoint = '';
    
    if (paymentType === 'alipay') {
      apiEndpoint = '/aliPayMobile/pay';
    } else if (paymentType === 'wechat') {
      // 检查是否为微信浏览器
      if (isWechatBrowser()) {
        apiEndpoint = '/wxPayMobile/wxPayZb';
        
        // 为微信支付创建回调URL
        const baseURL = getBaseURL();
        const callbackUrl = `${window.location.origin}/wechat-callback?orderNumber=${orderNumber.value}`;
        const paymentUrl = `${baseURL}${apiEndpoint}?redirectUri=${encodeURIComponent(callbackUrl)}`;
        
        // 直接跳转到微信支付页面
        window.open(paymentUrl, '_blank');
        return;
      } else {
        apiEndpoint = '/wxPayMobile/pay';
      }
    }
    
    const baseURL = getBaseURL();
    const paymentUrl = `${baseURL}${apiEndpoint}?orderNumber=${orderNumber.value}`;
    
    // 在新窗口打开支付接口地址
    window.open(paymentUrl, '_blank');
    
    // 启动轮询检查支付状态
    startPolling();
    
  } catch (error) {
    console.error(`移动端${paymentType === 'alipay' ? '支付宝' : '微信'}支付失败:`, error);
    ElMessage.error('支付请求失败，请重试');
  } finally {
    isLoadingPayment.value = false;
  }
};

// 处理激活码支付
const handleActivationCodePayment = async () => {
  if (!activationCode.value.trim()) {
    ElMessage.warning('请输入激活码');
    return;
  }

  if (!orderNumber.value) {
    ElMessage.error('订单号不存在，请重新生成订单');
    return;
  }

  try {
    isLoadingActivation.value = true;

    // 创建FormData对象
    const formData = new FormData();
    formData.append('orderNumber', orderNumber.value);
    formData.append('activationCode', activationCode.value.trim());

    const response = await useActivationCode(formData);

    if (response.data && response.data.code === 0) {
      // 激活码使用成功
      ElMessage.success('激活码使用成功，支付完成！');

      // 触发支付成功逻辑
      emit('update:visible', false);
      emit('payment-success', orderNumber.value);

      // 清空激活码输入
      activationCode.value = '';
    } else {
      // 激活码使用失败，显示错误信息
      const errorMsg = response.data?.msg || '激活码使用失败，请检查激活码是否正确';
      ElMessage.error(errorMsg);
    }
  } catch (error) {
    console.error('激活码支付失败:', error);
    ElMessage.error('激活码使用失败，请重试');
  } finally {
    isLoadingActivation.value = false;
  }
};

// 处理移动端激活码支付
const handleMobileActivationPayment = async () => {
  if (!mobileActivationCode.value.trim()) {
    ElMessage.warning('请输入激活码');
    return;
  }

  if (!orderNumber.value) {
    ElMessage.error('订单号不存在，请重新生成订单');
    return;
  }

  try {
    isLoadingActivation.value = true;

    // 创建FormData对象
    const formData = new FormData();
    formData.append('orderNumber', orderNumber.value);
    formData.append('activationCode', mobileActivationCode.value.trim());

    const response = await useActivationCode(formData);

    if (response.data && response.data.code === 0) {
      // 激活码使用成功
      ElMessage.success('激活码使用成功，支付完成！');

      // 关闭移动端激活码弹窗
      showMobileActivationDialog.value = false;

      // 触发支付成功逻辑
      emit('update:visible', false);
      emit('payment-success', orderNumber.value);

      // 清空激活码输入
      mobileActivationCode.value = '';
      activationCode.value = '';
    } else {
      // 激活码使用失败，显示错误信息
      const errorMsg = response.data?.msg || '激活码使用失败，请检查激活码是否正确';
      ElMessage.error(errorMsg);
    }
  } catch (error) {
    console.error('移动端激活码支付失败:', error);
    ElMessage.error('激活码使用失败，请重试');
  } finally {
    isLoadingActivation.value = false;
  }
};

// 生成二维码的辅助函数
const generateQRCode = async (text: string): Promise<string> => {
  try {
    const qrCodeDataUrl = await QRCode.toDataURL(text, {
      width: 200,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#FFFFFF'
      }
    });
    return qrCodeDataUrl;
  } catch (error) {
    console.error('生成二维码失败:', error);
    throw error;
  }
};

// 获取微信支付二维码
const getWechatPayQrCode = async () => {
  try {
    isLoadingQrCode.value = true;
    
    if (!orderNumber.value) {
      ElMessage.error('订单号不存在，请重新生成订单');
      return;
    }
    
    // 创建FormData对象
    const formData = new FormData();
    formData.append('orderNumber', orderNumber.value);
    
    const response = await post('/wxPay/pay', formData);
    
    if (response.data && response.data.data) {
      // 解析返回的数据
      const responseData = response.data.data;
      
      let paymentUrl = '';
      
      // 如果返回的是字符串，说明是支付URL
      if (typeof responseData === 'string') {
        paymentUrl = responseData;
      } else if (typeof responseData === 'object') {
        paymentUrl = responseData.payUrl || responseData.url || responseData.data;
      }
      
      // 使用本地qrcode库生成二维码
      if (paymentUrl) {
        const qrCodeDataUrl = await generateQRCode(paymentUrl);
        wechatQrCode.value = qrCodeDataUrl;
      }
    }
    
    // 启动轮询检查支付状态
    startPolling();
  } catch (error) {
    console.error('获取微信支付二维码失败:', error);
    ElMessage.error('获取支付二维码失败，请重试');
  } finally {
    isLoadingQrCode.value = false;
  }
};

// 获取支付宝二维码
const getAlipayQrCode = async () => {
  try {
    isLoadingQrCode.value = true;
    
    if (!orderNumber.value) {
      ElMessage.error('订单号不存在，请重新生成订单');
      return;
    }
    
    // 创建FormData对象
    const formData = new FormData();
    formData.append('orderNumber', orderNumber.value);
    
    const response = await post('/aliPay/pay', formData);
    
    if (response.data && response.data.data) {
      // 解析返回的数据
      const responseData = response.data.data;
      
      // 如果返回的是字符串，说明是HTML页面代码
      if (typeof responseData === 'string') {
        alipayHtml.value = responseData;
      } else if (typeof responseData === 'object') {
        const htmlContent = responseData.html || responseData.data;
        if (htmlContent) {
          alipayHtml.value = htmlContent;
        }
        
        // 如果同时有支付URL，也生成二维码
        const paymentUrl = responseData.payUrl || responseData.url;
        if (paymentUrl) {
          const qrCodeDataUrl = await generateQRCode(paymentUrl);
          alipayQrCode.value = qrCodeDataUrl;
        }
      }
    }
    
    // 启动轮询检查支付状态
    startPolling();
  } catch (error) {
    console.error('获取支付宝二维码失败:', error);
    ElMessage.error('获取支付二维码失败，请重试');
  } finally {
    isLoadingQrCode.value = false;
  }
};

// 检查订单支付状态
const checkOrderStatus = async () => {
  if (!orderNumber.value) {
    return;
  }
  
  try {
    const response = await get('/aiGenerate/getOrderStatus', {
      orderNumber: orderNumber.value
    });
    
    if (response.data && response.data.data === 1) {
      // 支付成功
      ElMessage.success('支付成功，请通过订单号查询生成进度！');
      stopPolling();
      emit('update:visible', false);
      // 触发支付成功事件，让父组件显示订单下载弹窗
      emit('payment-success', orderNumber.value);
    }
  } catch (error) {
    console.error('检查订单状态失败:', error);
  }
};

// 开始轮询
const startPolling = () => {
  if (pollTimer.value) {
    clearInterval(pollTimer.value);
  }
  
  pollTimer.value = setInterval(() => {
    checkOrderStatus();
  }, 3000); // 每3秒检查一次
};

// 停止轮询
const stopPolling = () => {
  if (pollTimer.value) {
    clearInterval(pollTimer.value);
    pollTimer.value = null;
  }
};

// 监听支付方式变化
watch(activePayment, (newPayment) => {
  // 切换支付方式时停止之前的轮询
  stopPolling();

  if (newPayment === 'wechat') {
    alipayHtml.value = ''; // 重置支付宝HTML内容
    getWechatPayQrCode();
  } else if (newPayment === 'alipay') {
    getAlipayQrCode();
  } else if (newPayment === 'activationCode') {
    // 激活码支付不需要生成二维码
    alipayHtml.value = ''; // 重置支付宝HTML内容
  }
});

// 监听登录状态变化
watch(() => props.isLoggedIn, async (newValue, oldValue) => {
  // 当用户从未登录变为已登录时，且弹窗是打开状态
  if (newValue && !oldValue && visible.value) {
    // 停止当前轮询
    stopPolling();
    
    // 重新获取用户折扣信息
    await fetchUserDiscount();
    
    // 重新生成订单（包括获取价格）
    await generateOrder();
    
    // PC端重新获取支付二维码
    if (!isMobile.value) {
      if (activePayment.value === 'wechat') {
        await getWechatPayQrCode();
      } else if (activePayment.value === 'alipay') {
        await getAlipayQrCode();
      }
    }
    
    ElMessage.success('登录成功，订单已更新');
  }
});

// 监听弹窗显示状态
watch(visible, async (newVisible) => {
  if (newVisible) {
    // 弹窗打开时先获取用户折扣信息
    await fetchUserDiscount();
    
    // 然后生成订单
    await generateOrder();
    
    // PC端默认调用微信支付接口
    if (!isMobile.value) {
      getWechatPayQrCode();
    }
  } else {
    // 弹窗关闭时重置HTML内容和停止轮询
    alipayHtml.value = '';
    stopPolling();
  }
});

// 组件挂载时不需要自动获取价格，等弹窗打开时生成订单
onMounted(() => {
  // 组件挂载时不执行任何操作，等待弹窗打开时生成订单
});

// 组件卸载时停止轮询
onUnmounted(() => {
  stopPolling();
});

</script>

<style scoped>
.order-details {
  font-family: 'Arial', sans-serif;
}

.section {
  margin-bottom: 20px;
  border: 1px solid #e8e8e8;
  padding: 15px;
  border-radius: 8px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.detail-item {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.label {
  color: #666;
  width: 80px;
  text-align: right;
  margin-right: 10px;
}

.value {
  color: #333;
}
.title-bg {
  background-color: #f0f2ff;
  padding: 2px 8px;
  border-radius: 4px;
}

.payment-methods {
  display: flex;
  margin-bottom: 15px;
}

.payment-method {
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-right: 10px;
  cursor: pointer;
}

.payment-method.active {
  border-color: #409eff;
  background-color: #ecf5ff;
}

.payment-content {
  display: flex;
  align-items: center;
}

.qr-code-container {
  margin-right: 20px;
  border: 1px solid #e8e8e8;
  padding: 10px;
  border-radius: 4px;
}

.qr-code-image {
  width: 140px;
  height: 140px;
}

.qr-code-image[srcdoc] {
  width: 140px;
  height: 140px;
  border: none;
  border-radius: 4px;
}

.loading-container {
  width: 140px;
  height: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background-color: #f9f9f9;
}

.loading-icon {
  font-size: 24px;
  color: #409eff;
  animation: rotate 1s linear infinite;
  margin-bottom: 8px;
}

.loading-text {
  font-size: 12px;
  color: #666;
  text-align: center;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.payment-info {
  text-align: left;
}
.scan-text {
  font-size: 16px;
  margin-bottom: 10px;
}

.amount {
  font-size: 24px;
  font-weight: bold;
  color: #f56c6c;
  margin-bottom: 10px;
}

.original-price {
  font-size: 0.7em;
  color: #999;
  margin-left: 10px;
  font-weight: normal;
}

.payment-prompt {
  font-size: 12px;
  color: #999;
}

/* 折扣提示样式 */
.discount-tip {
  margin-top: 12px;
  margin-bottom: 16px;
  text-align: center;
}

.discount-tip-pc {
  margin-top: 8px;
  margin-bottom: 8px;
}

.benefits-link {
  appearance: none;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin: 0 0 10px;
  padding: 7px 11px;
  border: 1px solid #e4eaf3;
  border-radius: 10px;
  background: #f8fafc;
  color: #4b5565;
  box-shadow: 0 2px 8px rgba(31, 41, 55, 0.05);
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.benefits-link > .el-icon:first-child {
  color: #f56c6c;
  font-size: 15px;
}

.benefits-link-arrow {
  color: #9aa4b2;
  font-size: 13px;
  transition: transform 0.2s ease;
}

.benefits-link:hover,
.benefits-link:focus-visible {
  border-color: #b8cdf8;
  color: #2563eb;
  box-shadow: 0 5px 14px rgba(37, 99, 235, 0.12);
  outline: none;
  transform: translateY(-1px);
}

.benefits-link:hover .benefits-link-arrow,
.benefits-link:focus-visible .benefits-link-arrow {
  transform: translateX(3px);
}

.login-tip {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #ffffff;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 13px;
  cursor: pointer;
  display: inline-block;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
  position: relative;
  overflow: hidden;
  animation: pulse 2s ease-in-out infinite, gradient-shift 3s ease infinite;
  background-size: 200% 200%;
}

.login-tip::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    45deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  animation: shine 3s ease-in-out infinite;
}

.login-tip:hover {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  animation: pulse 1s ease-in-out infinite, gradient-shift 2s ease infinite;
}

@keyframes pulse {
  0%, 100% {
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
  }
  50% {
    box-shadow: 0 4px 16px rgba(102, 126, 234, 0.6), 0 0 20px rgba(102, 126, 234, 0.4);
  }
}

@keyframes gradient-shift {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

@keyframes shine {
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) translateY(100%) rotate(45deg);
  }
}

.discount-info {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: #ffffff;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 13px;
  display: inline-block;
  box-shadow: 0 2px 8px rgba(245, 87, 108, 0.3);
}

.discount-info strong {
  font-weight: 700;
  font-size: 14px;
}

/* 移动端支付样式 */
.mobile-payment {
  text-align: center;
  padding: 20px 0;
}

.payment-amount {
  font-size: 18px;
  font-weight: bold;
  color: #f56c6c;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.payment-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.payment-btn {
  height: 50px;
  font-size: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.alipay-btn {
  background-color: #1677ff;
  border-color: #1677ff;
}

.alipay-btn:hover {
  background-color: #0958d9;
  border-color: #0958d9;
}

.wechat-btn {
  background-color: #07c160;
  border-color: #07c160;
}

.wechat-btn:hover {
  background-color: #06ad56;
  border-color: #06ad56;
}

.payment-tips {
  margin-top: 16px;
}

.tip-item {
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .mobile-dialog :deep(.el-dialog) {
    margin: 5vh auto !important;
    max-width: 90vw;
  }
  
  .mobile-dialog :deep(.el-dialog__body) {
    padding: 16px;
  }
  
  .section {
    margin-bottom: 20px;
  }
  
  .detail-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .label {
    font-size: 13px;
    min-width: auto;
  }
  
  .value {
    font-size: 13px;
  }
  
  .title-bg {
    font-size: 12px;
    padding: 4px 8px;
  }
  
  .qr-code-container {
    margin-right: 0;
    margin-bottom: 16px;
    text-align: center;
  }
  
  .qr-code-image {
    width: 120px;
    height: 120px;
  }
  
  .qr-code-image[srcdoc] {
    width: 120px;
    height: 120px;
  }
  
  .loading-container {
    width: 120px;
    height: 120px;
  }
  
  .payment-content {
    flex-direction: column;
    align-items: center;
  }
  
  .payment-info {
    text-align: center;
  }
  
  .scan-text {
    font-size: 14px;
  }
  
  .amount {
    font-size: 20px;
  }
  
  .payment-prompt {
    font-size: 11px;
  }
  
  .section-title {
    font-size: 14px;
    margin-bottom: 12px;
  }
  
  .payment-amount {
    font-size: 16px;
    margin-bottom: 16px;
  }
  
  .payment-btn {
    height: 44px;
    font-size: 15px;
  }
}

/* 激活码支付样式 */
.activation-code-container {
  padding: 20px;
  text-align: center;
}

.activation-input-wrapper {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  align-items: center;
  justify-content: center;
}

.activation-input {
  flex: 1;
  max-width: 300px;
}

.activation-btn {
  height: 40px;
  padding: 0 24px;
  font-size: 14px;
  border-radius: 6px;
  white-space: nowrap;
}

.activation-tips {
  margin-top: 16px;
}

.activation-tips .tip-item {
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
  line-height: 1.4;
}

/* 移动端激活码样式适配 */
@media (max-width: 768px) {
  .activation-code-container {
    padding: 16px;
  }

  .activation-input-wrapper {
    flex-direction: column;
    gap: 12px;
  }

  .activation-input {
    max-width: 100%;
    width: 100%;
  }

  .activation-btn {
    width: 100%;
    height: 44px;
  }
}

/* 移动端激活码按钮样式 */
.activation-btn-mobile {
  background-color: #e6a23c !important;
  border-color: #e6a23c !important;
  color: #ffffff !important;
}

.activation-btn-mobile:hover {
  background-color: #cf9236 !important;
  border-color: #cf9236 !important;
}

.activation-btn-mobile:active {
  background-color: #b38328 !important;
  border-color: #b38328 !important;
}

/* 移动端激活码弹窗样式 */
.mobile-activation-dialog {
  border-radius: 8px;
}

.mobile-activation-content {
  padding: 20px 0;
}

.activation-input-section {
  margin-bottom: 24px;
}

.mobile-activation-input {
  width: 100%;
}

.activation-buttons {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.activation-buttons .el-button {
  flex: 1;
  height: 44px;
  font-size: 16px;
}

.mobile-activation-tips {
  margin-top: 16px;
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #e6a23c;
}

.mobile-activation-tips .tip-item {
  font-size: 13px;
  color: #666;
  margin-bottom: 8px;
  line-height: 1.5;
}

.mobile-activation-tips .tip-item:last-child {
  margin-bottom: 0;
}

/* 移动端激活码弹窗适配 */
@media (max-width: 768px) {
  .mobile-activation-dialog :deep(.el-dialog) {
    margin: 10vh auto !important;
    max-width: 90vw;
  }

  .mobile-activation-dialog :deep(.el-dialog__body) {
    padding: 16px;
  }

  .mobile-activation-content {
    padding: 10px 0;
  }

  .activation-input-section {
    margin-bottom: 20px;
  }

  .activation-buttons {
    gap: 10px;
    margin-bottom: 16px;
  }

  .activation-buttons .el-button {
    height: 44px;
    font-size: 15px;
  }

  .mobile-activation-tips {
    padding: 12px;
  }

  .mobile-activation-tips .tip-item {
    font-size: 12px;
    margin-bottom: 6px;
  }
}

.paper-preview-box {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 10px 0;
  overflow-x: auto;
}

.preview-item {
  width: 280px;
  flex-shrink: 0;
}

.preview-page-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  color: #667085;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
}

.preview-page-meta span:last-child {
  color: #a1a9b5;
  font-variant-numeric: tabular-nums;
}

.preview-page {
  width: 280px;
  height: 397px;
  border: 1px solid #e8e8e8;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: relative;
  background-color: #fff;
  flex-shrink: 0;
}

.page-scaler {
  width: 800px;
  height: 1133px; /* Approx A4 aspect ratio */
  transform: scale(0.35);
  transform-origin: top left;
  background-color: #fff;
  overflow: hidden;
}

@media (max-width: 768px) {
  .preview-section {
    padding: 14px;
  }

  .paper-preview-box {
    flex-direction: column;
    align-items: center;
    gap: 22px;
    padding: 2px 0 8px;
    overflow: visible;
  }

  .preview-item {
    width: 256px;
    max-width: 100%;
  }

  .preview-page {
    width: 256px;
    height: 363px;
    max-width: 100%;
    border-color: #e2e7ee;
    border-radius: 4px;
    box-shadow: 0 10px 26px rgba(30, 41, 59, 0.11);
  }

  .page-scaler {
    transform: scale(0.32);
  }

  .mobile-payment > .benefits-link {
    display: flex;
    width: fit-content;
    margin: -4px auto 16px;
  }
}

@media (max-width: 370px) {
  .preview-item,
  .preview-page {
    width: 224px;
  }

  .preview-page {
    height: 317px;
  }

  .page-scaler {
    transform: scale(0.28);
  }
}
</style>
